// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@keyframes in-btn-social-fbe2bf42{0%{left:-110%;top:90%}50%{left:10%;top:-30%}100%{top:-10%;left:-10%}}@keyframes out-btn-social-fbe2bf42{0%{top:-10%;left:-10%}50%{left:10%;top:-30%}100%{left:-110%;top:90%}}.input-template.wider[data-v-fbe2bf42]{width:100%}.input-template.primary[data-v-fbe2bf42] .fs-label{color:#1c1c1c}", ""]);
// Exports
module.exports = exports;
